import { BillingApiClient } from '@fourthwall/services/dist/BillingApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useBillingQuery = createQueryHook(BillingApiClient.getBilling, {
  queryKey: ['billing'],
})
